export const GET_ROOT_NODES_SCHEMA = 'GET_ROOT_NODES_SCHEMA';
export type GET_ROOT_NODES_SCHEMA = typeof GET_ROOT_NODES_SCHEMA;

export const GET_ROOT_NODES_SCHEMA_SUCCESS = 'GET_ROOT_NODES_SCHEMA_SUCCESS';
export type GET_ROOT_NODES_SCHEMA_SUCCESS = typeof GET_ROOT_NODES_SCHEMA_SUCCESS;

export const GET_ROOT_NODES_SCHEMA_FAILED = 'GET_ROOT_NODES_SCHEMA_FAILED';
export type GET_ROOT_NODES_SCHEMA_FAILED = typeof GET_ROOT_NODES_SCHEMA_FAILED;

export const GET_CHILD_NODES_SCHEMA = 'GET_CHILD_NODES_SCHEMA';
export type GET_CHILD_NODES_SCHEMA = typeof GET_CHILD_NODES_SCHEMA;

export const GET_CHILD_NODES_SCHEMA_SUCCESS = 'GET_CHILD_NODES_SCHEMA_SUCCESS';
export type GET_CHILD_NODES_SCHEMA_SUCCESS = typeof GET_CHILD_NODES_SCHEMA_SUCCESS;

export const GET_CHILD_NODES_SCHEMA_FAILED = 'GET_CHILD_NODES_SCHEMA_FAILED';
export type GET_CHILD_NODES_SCHEMA_FAILED = typeof GET_CHILD_NODES_SCHEMA_FAILED;

export const COLLAPSE_SCHEMA_NODE = 'COLLAPSE_SCHEMA_NODE';
export type COLLAPSE_SCHEMA_NODE = typeof COLLAPSE_SCHEMA_NODE;

export const SELECT_SCHEMA_NODE = 'SELECT_SCHEMA_NODE';
export type SELECT_SCHEMA_NODE = typeof SELECT_SCHEMA_NODE;

export const ADD_ROOT_NODE_SCHEMA = 'ADD_ROOT_NODE_SCHEMA';
export type ADD_ROOT_NODE_SCHEMA = typeof ADD_ROOT_NODE_SCHEMA;

export const ADD_ROOT_NODE_SCHEMA_SUCCESS = 'ADD_ROOT_NODE_SCHEMA_SUCCESS';
export type ADD_ROOT_NODE_SCHEMA_SUCCESS = typeof ADD_ROOT_NODE_SCHEMA_SUCCESS;

export const ADD_ROOT_NODE_SCHEMA_FAILED = 'ADD_ROOT_NODE_SCHEMA_FAILED';
export type ADD_ROOT_NODE_SCHEMA_FAILED = typeof ADD_ROOT_NODE_SCHEMA_FAILED;

export const EDIT_ROOT_NODE_SCHEMA = 'EDIT_ROOT_NODE_SCHEMA';
export type EDIT_ROOT_NODE_SCHEMA = typeof EDIT_ROOT_NODE_SCHEMA;

export const EDIT_ROOT_NODE_SCHEMA_SUCCESS = 'EDIT_ROOT_NODE_SCHEMA_SUCCESS';
export type EDIT_ROOT_NODE_SCHEMA_SUCCESS = typeof EDIT_ROOT_NODE_SCHEMA_SUCCESS;

export const EDIT_ROOT_NODE_SCHEMA_FAILED = 'EDIT_ROOT_NODE_SCHEMA_FAILED';
export type EDIT_ROOT_NODE_SCHEMA_FAILED = typeof EDIT_ROOT_NODE_SCHEMA_FAILED;

export const DELETE_ROOT_NODE_SCHEMA = 'DELETE_ROOT_NODE_SCHEMA';
export type DELETE_ROOT_NODE_SCHEMA = typeof DELETE_ROOT_NODE_SCHEMA;

export const DELETE_ROOT_NODE_SCHEMA_SUCCESS =
  'DELETE_ROOT_NODE_SCHEMA_SUCCESS';
export type DELETE_ROOT_NODE_SCHEMA_SUCCESS = typeof DELETE_ROOT_NODE_SCHEMA_SUCCESS;

export const DELETE_ROOT_NODE_SCHEMA_FAILED = 'DELETE_ROOT_NODE_SCHEMA_FAILED';
export type DELETE_ROOT_NODE_SCHEMA_FAILED = typeof DELETE_ROOT_NODE_SCHEMA_FAILED;

export const ADD_CHILD_NODE_SCHEMA = 'ADD_CHILD_NODE_SCHEMA';
export type ADD_CHILD_NODE_SCHEMA = typeof ADD_CHILD_NODE_SCHEMA;

export const ADD_CHILD_NODE_SCHEMA_SUCCESS = 'ADD_CHILD_NODE_SCHEMA_SUCCESS';
export type ADD_CHILD_NODE_SCHEMA_SUCCESS = typeof ADD_CHILD_NODE_SCHEMA_SUCCESS;

export const ADD_CHILD_NODE_SCHEMA_FAILED = 'ADD_CHILD_NODE_SCHEMA_FAILED';
export type ADD_CHILD_NODE_SCHEMA_FAILED = typeof ADD_CHILD_NODE_SCHEMA_FAILED;

export const EDIT_CHILD_NODE_SCHEMA = 'EDIT_CHILD_NODE_SCHEMA';
export type EDIT_CHILD_NODE_SCHEMA = typeof EDIT_CHILD_NODE_SCHEMA;

export const EDIT_CHILD_NODE_SCHEMA_SUCCESS = 'EDIT_CHILD_NODE_SCHEMA_SUCCESS';
export type EDIT_CHILD_NODE_SCHEMA_SUCCESS = typeof EDIT_CHILD_NODE_SCHEMA_SUCCESS;

export const EDIT_CHILD_NODE_SCHEMA_FAILED = 'EDIT_CHILD_NODE_SCHEMA_FAILED';
export type EDIT_CHILD_NODE_SCHEMA_FAILED = typeof EDIT_CHILD_NODE_SCHEMA_FAILED;

export const DELETE_CHILD_NODE_SCHEMA = 'DELETE_CHILD_NODE_SCHEMA';
export type DELETE_CHILD_NODE_SCHEMA = typeof DELETE_CHILD_NODE_SCHEMA;

export const DELETE_CHILD_NODE_SCHEMA_SUCCESS =
  'DELETE_CHILD_NODE_SCHEMA_SUCCESS';
export type DELETE_CHILD_NODE_SCHEMA_SUCCESS = typeof DELETE_CHILD_NODE_SCHEMA_SUCCESS;

export const DELETE_CHILD_NODE_SCHEMA_FAILED =
  'DELETE_CHILD_NODE_SCHEMA_FAILED';
export type DELETE_CHILD_NODE_SCHEMA_FAILED = typeof DELETE_CHILD_NODE_SCHEMA_FAILED;

export const GET_SCHEMA_NODE_PROPERTIES = 'GET_SCHEMA_NODE_PROPERTIES';
export type GET_SCHEMA_NODE_PROPERTIES = typeof GET_SCHEMA_NODE_PROPERTIES;

export const GET_SCHEMA_NODE_PROPERTIES_SUCCESS =
  'GET_SCHEMA_NODE_PROPERTIES_SUCCESS';
export type GET_SCHEMA_NODE_PROPERTIES_SUCCESS = typeof GET_SCHEMA_NODE_PROPERTIES_SUCCESS;

export const GET_SCHEMA_NODE_PROPERTIES_FAILED =
  'GET_SCHEMA_NODE_PROPERTIES_FAILED';
export type GET_SCHEMA_NODE_PROPERTIES_FAILED = typeof GET_SCHEMA_NODE_PROPERTIES_FAILED;

export const ADD_PROPERTY_SCHEMA = 'ADD_PROPERTY_SCHEMA';
export type ADD_PROPERTY_SCHEMA = typeof ADD_PROPERTY_SCHEMA;

export const ADD_PROPERTY_SCHEMA_SUCCESS = 'ADD_PROPERTY_SCHEMA_SUCCESS';
export type ADD_PROPERTY_SCHEMA_SUCCESS = typeof ADD_PROPERTY_SCHEMA_SUCCESS;

export const ADD_PROPERTY_SCHEMA_FAILED = 'ADD_PROPERTY_SCHEMA_FAILED';
export type ADD_PROPERTY_SCHEMA_FAILED = typeof ADD_PROPERTY_SCHEMA_FAILED;

export const EDIT_PROPERTY_SCHEMA = 'EDIT_PROPERTY_SCHEMA';
export type EDIT_PROPERTY_SCHEMA = typeof EDIT_PROPERTY_SCHEMA;

export const EDIT_PROPERTY_SCHEMA_SUCCESS = 'EDIT_PROPERTY_SCHEMA_SUCCESS';
export type EDIT_PROPERTY_SCHEMA_SUCCESS = typeof EDIT_PROPERTY_SCHEMA_SUCCESS;

export const EDIT_PROPERTY_SCHEMA_FAILED = 'EDIT_PROPERTY_SCHEMA_FAILED';
export type EDIT_PROPERTY_SCHEMA_FAILED = typeof EDIT_PROPERTY_SCHEMA_FAILED;
